import React, { lazy } from 'react';
import { RouteConfig } from 'react-router-config';
import IconDiagnose from '@/assets/images/menu/icon-observability.react.svg?react';
import { isAndroid } from '@/infrastructure/product-info';
import { MenuIcon } from '@/presentation/components/menu-icon';

// 临时使用一个通用图标，后续可以替换为专门的图标

export const llmObservabilityRoutes = (): RouteConfig[] => {
  if (!isAndroid()) {
    return [];
  }

  return [
    {
      path: '/llm-observability',
      name: '大模型可观测',
      icon: <MenuIcon icon={IconDiagnose} fontSize={16} />,
      component: lazy(() => import('@/presentation/pages/llm-observability')),
    },
  ];
};
